export default "__VITE_ASSET__ChVxu3FH__"